import React, { useCallback, useEffect, useMemo, useRef } from "react";

export function useDebounce(fn, delay) {
  const fnRef = useRef(fn);
  const tRef = useRef();
  const lastArgs = useRef([]);

  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  const debounced = useCallback(
    (...args) => {
      lastArgs.current = args;
      if (tRef.current) clearTimeout(tRef.current);
      tRef.current = setTimeout(() => {
        tRef.current = undefined;
        fnRef.current(...lastArgs.current);
      }, delay);
    },
    [delay]
  );

  const cancel = useCallback(() => {
    if (tRef.current) {
      clearTimeout(tRef.current);
      tRef.current = undefined;
    }
  }, []);

  const flush = useCallback(() => {
    if (tRef.current) {
      clearTimeout(tRef.current);
      tRef.current = undefined;
      fnRef.current(...lastArgs.current);
    }
  }, []);

  return useMemo(
    () => Object.assign(debounced, { cancel, flush }),
    [debounced, cancel, flush]
  );
}
